import { IconButton, Typography, makeStyles, Box } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import * as React from "react";

import theme from "@/theme";
import { isIos } from "@/utilities/capacitorLogic";

export const HEADER_HEIGHT = 56;

const useStyles = makeStyles(() => ({
  header: {
    padding: "0 16px",
    paddingTop: isIos ? "env(safe-area-inset-top, 0px)" : 0,
    height: isIos ? `calc(${HEADER_HEIGHT}px + env(safe-area-inset-top, 0px))` : HEADER_HEIGHT,
    backgroundColor: theme.palette.semantic["surface/card"],
    borderBottom: `1px solid ${theme.palette.semantic["border/default"]}`,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  slot: {
    minWidth: 40,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiIconButton-root": { padding: 8, width: 40, height: 40 },
    "& .MuiSvgIcon-root": { width: 24, height: 24 },
  },
  backButton: { color: theme.palette.semantic["icon/default"] },
  title: { flex: 1, minWidth: 0, textAlign: "center", fontSize: 16, fontWeight: 700, lineHeight: 1.3 },
}));

interface HeaderProps {
  title?: string;
  onBack?: () => void;
  ActionComponent?: React.ReactNode;
  BackIconComponent?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, onBack, ActionComponent, BackIconComponent }) => {
  const classes = useStyles();
  return (
    <Box component="header" className={classes.header}>
      <Box className={classes.slot}>
        {onBack && (
          <IconButton aria-label="戻る" className={classes.backButton} onClick={onBack}
            style={BackIconComponent ? { padding: 0 } : undefined}>
            {BackIconComponent || <ArrowBackIcon />}
          </IconButton>
        )}
      </Box>
      <Typography component="h1" className={classes.title}>
        {title}
      </Typography>
      <Box className={classes.slot}>{ActionComponent}</Box>
    </Box>
  );
};

export default Header;
